export const LISTBOX_TEXT = {
  /** status=empty(또는 선택지가 없을 때)의 안내 */
  empty: '항목이 없습니다',
  /** status=loading 의 보조기기 문구 */
  loading: '목록을 불러오는 중',
} as const;
